import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const ComponentSubmitButton = ({ title, id = false, theme = '' }) => {
    const [isLoading, toggleLoading] = useState(false);
    const iconStyle = { opacity: isLoading ? 1 : 0 };
    const textStyle = { opacity: isLoading ? 0 : 1 };
    const onClick = () => {
        let isValid = true;
        if (id) {
            const form = document.getElementsByName(id);
            if (form && form[0]) {
                isValid = form[0].checkValidity();
            }
        }
        if (isValid) {
            toggleLoading(true);
        }
    };
    return (_jsxs("button", Object.assign({ type: 'submit', className: `button ${theme}`, onClick: onClick }, { children: [_jsx("span", Object.assign({ className: 'button--spinner' }, { children: _jsx("i", { className: 'fas fa-spinner-third fa-spin', style: iconStyle }) })), _jsx("span", Object.assign({ style: textStyle }, { children: title }))] })));
};
ComponentSubmitButton.propTypes = {
    title: PropTypes.string.isRequired,
    theme: PropTypes.string
};
export default ComponentSubmitButton;
